module.exports = "<p>\n  training-record-from works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Training/training-record/training-record-from/training-record-from.component.html
// module id = ./src/app/hrms/Training/training-record/training-record-from/training-record-from.component.html
// module chunks = main